import type { Route } from '@angular/router';
import { dirtyCheckCanDeactivateGuard } from '../../../common/dirty-check/dirty-check';
import { hasStringPathParamCanActivateGuard } from '@pct/ng-core-router';

export const offerCategoryRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/offer-category-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () => import('../../../common/category-details/category-details.component'),
    title: 'PAGES.OFFER.CATEGORY.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('../../../common/category-details/category-details.component'),
    title: 'PAGES.OFFER.CATEGORY.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
];
